import React, { useEffect, useMemo, useState } from "react"
import "./CharacterizationScreen.scss"
import CharacterizationWrapper from "./components/CharacterizationWrapper/CharacterizationWrapper"
import CharacterizationMultipleQuestion from "./components/CharacterizationMultipleQuestion/CharacterizationMultipleQuestion"
import CharacterizationRadioQuestion from './components/CharacterizationRadioQuestion/CharacterizationRadioQuestion';
import CharacterizationSelectQuestion from "./components/CharacterizationSelectQuestion/CharacterizationSelectQuestion"
import { IResourceEditor } from "app_types/editor/editorTypes"
import { IQuestionEditor } from "app_components/modules/academicComponentEditor/containers/academicComponentEditorFunctions"
import { IAttemptSurvey } from "app_types/admin/survey/survet.types";
import EditorService from "app_services/editor/editorService";
import { useSelector } from "react-redux";
import { CombinedReducers } from "app_events/index";
import * as InteractionTypes from 'app_events/interaction/types'

const IMAGE = require("app_assets/images/resources/characterization-image.png")

interface ICharacterizationScreenProps {
  resourceData: IResourceEditor
  path?: InteractionTypes.IPathInteraction
  onFinish?: () => void
}

function CharacterizationScreen ({ resourceData, path, onFinish }: ICharacterizationScreenProps){
  const [questions, setQuestions] = useState<IQuestionEditor[]>([])
  const [attempt, setAttempt] = useState<IAttemptSurvey>({statistics: [], questionsToEvaluate: []})
  const [loading, setLoading] = useState<boolean>(false)
  const user = useSelector((state: CombinedReducers) => state.auth.user)

  const editorService = useMemo(() => new EditorService(), [])

  useEffect(() => {
    if (resourceData?.config?.questions?.[0]?.childs?.length) {
      setQuestions(resourceData?.config?.questions?.[0]?.childs)
    } else {
      setQuestions([])
    }
    if (resourceData?.config?.attempt_active) {
      setAttempt(resourceData?.config?.attempt_active?.results)
    }
  }, [resourceData])

  const handleChangeStep = () => {
    handleSendQuestions()
  }

  const handleSubmitSurvey = () => {
    handleSendQuestions(true)
  }

  const handleSendQuestions = async (qualify?: boolean) => {
    setLoading(true)
    let results = {...attempt}
    if (qualify) {
      results['status'] = 'ended';
    }

    const params = {
      results,
      academic_resource_config: path?.academic_resource_config,
      user: user?.data?.id,
      deliverable_date: (new Date())
    }
    const response = await editorService.sendAttemptResults(params, qualify ? true : false)
    if (response.code === 200 && qualify) {
      onFinish && onFinish()
    }
    setLoading(false)
  }

  const getQuestionToRender = (question: IQuestionEditor) => {
    switch(question.question?.question_category?.name) {
      case 'multiple-choice-unique-answer':
        return question?.question?.config?.show_as_select ? (
          <CharacterizationSelectQuestion
            question={question}
            attempt={attempt}
            setAttempt={setAttempt}
            key={question._id}
          />
        ) : (
          <CharacterizationRadioQuestion
            question={question}
            attempt={attempt}
            setAttempt={setAttempt}
            key={question._id}
          />
        )
      case 'multiple-choice-multiple-answer':
        return (
          <CharacterizationMultipleQuestion
            question={question}
            attempt={attempt}
            setAttempt={setAttempt}
            key={question._id}
          />
        )
    }
  }

  return (
    <div className="characterization-screen--contenedor-grande">
        <div className="characterization-screen--contenedor-imagen">
          <img className="characterization-screen--medida-imagen" src={IMAGE} alt="" />
        </div>
        <div className="characterization-screen--contenedor-formulario">
          <CharacterizationWrapper
            questions={questions}
            attempt={attempt}
            onSubmit={handleSubmitSurvey}
            onChangeStep={handleChangeStep}
            loading={loading}
          >
            {questions?.map((question) => (
              getQuestionToRender(question)
            ))}
          </CharacterizationWrapper>
        </div>
    </div>
  )
}

export default CharacterizationScreen
